export enum LocalStorageKeys {
  ARCHIVE_IN_USE = 'archive-in-use',
  PREFERRED_ARCHIVE_USER = 'preferred-archive-user',
  DOMUSTUDIO_WEB_SESSION_KEY = 'domustudio-web-session',
  OFFLINE_QUEUE = 'offline-queue',
  LOCAL_USER_SETTING = 'local-user-settings-DG'
}
